import GaiaIcon from '@gaia/icons/GaiaIcon';
import type {SharedData} from '@gaia/types';
import {MapboxControlButton, MapboxControlGroup} from '@gaia/utils/mapbox/MapboxControl';
import SubscriptionTooltip from '@map/SubscriptionTooltip';
import {stringifyUrlProps} from '@map/urlProps';

import classes from './Controls.module.css';

export interface FullscreenControlProps {
    sharedData: SharedData;
    map: mapboxgl.Map | undefined;
    userLayers: UserLayer[] | undefined;
}
export function FullscreenControl({map, sharedData, userLayers}: FullscreenControlProps) {
    const center = map?.getCenter().wrap();
    const zoom = map?.getZoom();

    return (
        <MapboxControlGroup>
            <MapboxControlButton
                aria-label='Fullscreen'
                className={classes.mapControl}
                onClick={() => {
                    if (!userLayers || !zoom || !center || !sharedData) return;
                    window.location.assign(
                        '/map/' +
                            stringifyUrlProps({
                                center,
                                zoom: zoom + 1,
                                sharedData,
                                selections:
                                    sharedData.type === 'area' ||
                                    sharedData.type === 'track' ||
                                    sharedData.type === 'waypoint'
                                        ? [
                                              {
                                                  type: sharedData.type,
                                                  localId: sharedData.id,
                                              },
                                          ]
                                        : [],
                                layers: userLayers
                                    .filter(({isVisible}) => isVisible)
                                    .map(({layer}) => layer.type),
                            })
                    );
                }}
            >
                <SubscriptionTooltip
                    enterDelay={500}
                    placement='right'
                    title='Fullscreen'
                    subscription={undefined}
                >
                    <GaiaIcon name='fullscreen' style={{width: 24, height: 24}} />
                </SubscriptionTooltip>
            </MapboxControlButton>
        </MapboxControlGroup>
    );
}
